import { SET_TURNOS_RECEPCIONADOS, SET_TURNOS_RECEPCIONADOS_ALL } from "../ActionTypes";

export const setTurnosRecepcionados = (turnoRecepcionado) => (dispatch) => {
  dispatch({ type: SET_TURNOS_RECEPCIONADOS, payload: turnoRecepcionado });
};

export const setTurnosRecepcionadosAll = (listTurnos) => (dispatch) => {
  dispatch({type: SET_TURNOS_RECEPCIONADOS_ALL,payload:listTurnos});
}